export default {
  zh: {
    notPaid: "订单列表",
    payment: "去支付",
    description: "说明",
    taxIncluded: "含税",
    amountUnpaid: "待付款金额(含税)",
    createTime: "创建日期",
    remark: "备注",
    orderType: "订单类型",
    paymentDueDate: "支付到期日",
    billingParty: "付款单位",
    status: "订单状态",
    refundStatus: "退款状态",
    invoice: "普通发票",
  },
  en: {
    notPaid: "Order list",
    payment: "To be paid",
    description: "Description",
    taxIncluded: "tax included",
    amountUnpaid: `Amount to be paid \n (tax included)`,
    createTime: "Create date",
    remark: "Remark",
    orderType: "Order type",
    paymentDueDate: "Payment due date",
    billingParty: "Billing party",
    status: "Order status",
    refundStatus: "Refund status",
    invoice: "Generic invoice",
  },
};
